import {
    SET_DATA_YIKI,
    SET_YIKI_REWARD
} from "@core/redux/actions/lottery/yiki";

const initialState = {
    list: [],
    result: null
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_DATA_YIKI:
            return { ...state, list: action.payload.items };
        case SET_YIKI_REWARD:
            return { ...state, result: action.payload.items };
        default:
            return state;

    }
}